import { bodyFont, colours } from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem } from "@affinity/constants/StyleHelpers";
import styled, { css } from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 5px;
    border-left: 5px solid ${colours.lightGreen};
    background: ${colours.lightBlue20};
    padding: ${rem(20)};
    gap: ${rem(10)};
    @media (min-width: ${breakpointWidth("lg")}) {
        padding: ${rem(30)};
        border-radius: 8px;
        border-left: 8px solid ${colours.lightGreen};
    }
`;

const Title = styled.h3`
    font-family: ${bodyFont};
    font-size: ${rem(20)};
    font-weight: 600;
    line-height: 1.3em;
    color: ${colours.black};
    @media (min-width: ${breakpointWidth("lg")}) {
        font-size: ${rem(26)};
    }
`;

const Text = styled.div`
    font-family: ${bodyFont};
    font-size: ${rem(16)};
    line-height: 1.6em;
    color: ${colours.black};
    @media (min-width: ${breakpointWidth("lg")}) {
        font-size: ${rem(18)};
    }
`;

const Badge = styled.span`
    flex-direction: column;
    align-items: flex-start;
    padding: ${rem(5)} ${rem(10)};
    font-size: ${rem(16)};
    font-weight: 600;
    line-height: 1.6em;
    border-radius: 0px 0px ${rem(5)} ${rem(5)};
    background: ${colours.green};
    color: ${colours.white};
    order: -2;
    margin-top: ${rem(-20)};
    margin-bottom: ${rem(10)};
    @media (min-width: ${breakpointWidth("lg")}) {
        margin-top: ${rem(-30)};
    }
`;

const ItemCard = {
    Container,
    Title,
    Text,
    Badge,
};

export default ItemCard;

export const ItemCardWrapperCss = css`
    font-style: normal;
    background-color: ${colours.lightBlue50};
    padding: ${rem(20)} ${rem(20)} ${rem(30)};
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    @media (min-width: ${rem(1200)}) {
        padding: ${rem(30)};
    }
`;
export const ItemCardTitleCss = css`
    font-size: ${rem(18)};
    line-height: 1.44;
    font-weight: 500;
    margin: 0 0 ${rem(5)} 0;
    @media (min-width: ${rem(1200)}) {
        font-size: ${rem(20)};
        line-height: 1.4;
    }
`;
export const ItemCardSubTitleCss = css`
    font-size: ${rem(15)};
    line-height: 1.33;
    font-weight: 300;
    margin: 0 0 ${rem(5)} 0;
    @media (min-width: ${rem(1200)}) {
        font-size: ${rem(16)};
        line-height: 1.5;
    }
`;

export const ItemCardButtonCss = css`
    margin: ${rem(15)} 0 0 0;
    @media (min-width: ${rem(1200)}) {
        margin: ${rem(20)} 0 0 0;
    }
`;

export const ItemCardGridContainerCss = css`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: ${rem(20)};
    padding: ${rem(20)} 0;
    @media (min-width: ${rem(768)}) {
        gap: ${rem(40)} ${rem(30)};
        grid-template-columns: 1fr 1fr 1fr;
        padding: ${rem(30)} 0;
    }
    @media (min-width: ${rem(1280)}) {
        gap: ${rem(40)};
        padding: ${rem(40)} 0;
    }
`;
